import {
  Box,
  InputAdornment,
  TextField,
  withStyles,
} from '@material-ui/core';
import { useCallback, useEffect, useMemo, useState, useTransition } from 'react';

import SearchIcon from '@material-ui/icons/Search';
import useTranslation from 'next-translate/useTranslation';
import debounce from 'lodash/debounce';

const StyledTextField = withStyles({
  root: {
    width: '100%',
    '& .MuiInput-root': {
      color: 'inherit',
      '& .MuiInputAdornment-root': {
        color: 'inherit',
      },
    },
  },
})(TextField);

export default function SearchBar({
  searchText = '',
  onSearch,
  label,
  ...props
}) {
  const { t } = useTranslation('common');
  const [, startTransition] = useTransition();

  const [localValue, setLocalValue] = useState(searchText);

  useEffect(() => {
    setLocalValue(searchText);
  }, [searchText]);

  const debouncedSearch = useMemo(
    () =>
      debounce((value) => {
        startTransition(() => {
          onSearch(value);
        });
      }, 500),
    [onSearch, startTransition]
  );

  const handleTextChange = useCallback(
    (event) => {
      const value = event.target.value || '';
      setLocalValue(value);
      debouncedSearch(value);
    },
    [debouncedSearch]
  );

  return (
    <Box mb={1} {...props}>
      <Box
        display="flex"
        flexWrap="nowrap"
        alignItems="center"
        minWidth={300}
        maxWidth={500}
      >
        <Box flexGrow={1}>
          <StyledTextField
            placeholder={`${t('Search')} ${label}`}
            value={localValue}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            onChange={handleTextChange}
          />
        </Box>
      </Box>
    </Box>
  );
}
